import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl, } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
} from "../../components"
import {
    Button, Select, SelectItem
} from "@nextui-org/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom"
import { Fragment, useEffect, useMemo, useRef, useState } from "react"
import { format } from "date-fns";
import { useCallback } from "react"
import { faInfo, faSearch, faServer } from "@fortawesome/free-solid-svg-icons"
import { formatCurrency, formatNumber } from "../../Utility/utility"

const ProfitNLossReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [billDate, setBillDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })
    const [selRptFormat, setSelRptFormat] = useState("INCEXP")
    const navi = useNavigate()

    useEffect(() => {
        if (isMultipleCompany)
            navi(linksUrl.dashboard.tradingDashboard)
    }, [])

    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.transaction.creditdebitnote.getProfitLossData,
        queryKey: "Credit Trial Balance Details",
    })


    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: billDate?.fromDate,
                to_date: billDate?.toDate,
            }
        })
    }


    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setBillDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: startDate,
                to_date: endDate,
            }
        })
    }


    const generateTradingData = useCallback((items) => {
        const tradingData = {
            Income: {},
            Expense: {}
        }

        let incomeTotal = 0
        let expenseTotal = 0

        items.forEach(item => {
            const type = item.DataType
            const group = item.Grp_Desc
            const amount = Math.abs(item.Balance)

            if (!tradingData[type][group]) tradingData[type][group] = []

            tradingData[type][group].push({
                desc: item.Ac_Desc,
                amount
            })

            if (type === "Income") incomeTotal += amount
            else expenseTotal += amount
        })

        return { tradingData, incomeTotal, expenseTotal }

    }, [])
    const rightRowRefs = useRef([]);
    const leftRowRefs = useRef([]);
    const { mainData, otherData } = useMemo(() => {
        const mainData = []
        const otherData = []

        data.forEach(d => {
            if ([26, 27].includes(d.Grp_Code) || [26, 27].includes(d.Grp_Under))
                otherData.push(d)
            else
                mainData.push(d)
        })

        return { mainData, otherData }
    }, [data])
    const main = useMemo(() => generateTradingData(mainData), [mainData])
    const other = useMemo(() => generateTradingData(otherData), [otherData])

    const getTotalRows = (groups) =>
        Object.values(groups).reduce((sum, rows) => sum + rows.length + 2, 0)
    const mainInc_totalRows = getTotalRows(main.tradingData.Income)
    const mainExp_totalRows = getTotalRows(main.tradingData.Expense)
    const otherInc_totalRows = getTotalRows(other.tradingData.Income)
    const otherExp_totalRows = getTotalRows(other.tradingData.Expense)



    //console.log(totalRows,totalRows1,main);
    const { grossProfit, netProfit, finalIncomeTotal, finalExpenseTotal } = useMemo(() => {

        const grossProfit = main.incomeTotal - main.expenseTotal
        const netProfit = grossProfit + other.incomeTotal - other.expenseTotal

        const finalIncomeTotal =
            other.incomeTotal +
            (grossProfit > 0 ? Math.abs(grossProfit) : 0) +
            (netProfit < 0 ? Math.abs(netProfit) : 0)

        const finalExpenseTotal =
            other.expenseTotal +
            (grossProfit < 0 ? Math.abs(grossProfit) : 0) +
            (netProfit > 0 ? netProfit : 0)

        return { grossProfit, netProfit, finalIncomeTotal, finalExpenseTotal }

    }, [main, other])



    const col_1Width = ' w-[70%]'
    const col_2Width = 'w-[30%]'
    const border_class = 'border border-gray-500 text-xs'

    const renderBlankRow = useCallback((maxVal, minVal) => {
        return Array.from({ length: maxVal - minVal }).map((_, i) => (
            <tr key={i}>
                <td className={` ${border_class} px-2 py-1`}>-</td>
                <td className={` ${border_class} px-2 py-1`}>-</td>
            </tr>
        ))
    }, [])
    // REPORT FORMAT CONTROL
    const { leftMainGroups, rightMainGroups, leftMainTotal, rightMainTotal, isIncomeLeft
        , leftOtherGroups, rightOtherGroups, leftOtherTotal, rightOtherTotal,
        leftTitle, rightTitle, leftOtherTitle, rightOtherTitle, leftMainRows, rightMainRows, leftOtherRows, rightOtherRows,
        showGrossProfitLeft, showGrossProfitRight, showGrossLossLeft, showGrossLossRight,
        showNetProfitLeft, showNetProfitRight, showNetLossLeft, showNetLossRight,

    } = useMemo(() => {

        const isIncomeLeft = selRptFormat === "INCEXP";

        // ---- TRADING ACCOUNT ----
        const leftMainGroups = isIncomeLeft
            ? main.tradingData.Income
            : main.tradingData.Expense;

        const rightMainGroups = isIncomeLeft
            ? main.tradingData.Expense
            : main.tradingData.Income;

        const leftMainTotal = isIncomeLeft ? main.incomeTotal : main.expenseTotal;
        const rightMainTotal = isIncomeLeft ? main.expenseTotal : main.incomeTotal;


        // ---- PROFIT & LOSS ACCOUNT ----
        const leftOtherGroups = isIncomeLeft
            ? other.tradingData.Income
            : other.tradingData.Expense;

        const rightOtherGroups = isIncomeLeft
            ? other.tradingData.Expense
            : other.tradingData.Income;

        const leftOtherTotal = isIncomeLeft ? other.incomeTotal : other.expenseTotal;
        const rightOtherTotal = isIncomeLeft ? other.expenseTotal : other.incomeTotal;


        // ---- HEADINGS ----
        const leftTitle = isIncomeLeft ? "INCOME" : "EXPENSE";
        const rightTitle = isIncomeLeft ? "EXPENSE" : "INCOME";

        const leftOtherTitle = isIncomeLeft ? "OTHER INCOME" : "EXPENSES (ADMIN)";
        const rightOtherTitle = isIncomeLeft ? "EXPENSES (ADMIN)" : "OTHER INCOME";

        // TRADING ROW COUNTS
        const leftMainRows = isIncomeLeft ? mainInc_totalRows : mainExp_totalRows;
        const rightMainRows = isIncomeLeft ? mainExp_totalRows : mainInc_totalRows;

        // OTHER ROW COUNTS
        const leftOtherRows = isIncomeLeft ? otherInc_totalRows : otherExp_totalRows;
        const rightOtherRows = isIncomeLeft ? otherExp_totalRows : otherInc_totalRows;

        // Determine which side Gross Profit should appear
        const showGrossProfitLeft = !isIncomeLeft && grossProfit > 0;
        const showGrossProfitRight = isIncomeLeft && grossProfit > 0;
        const showGrossLossLeft = isIncomeLeft && grossProfit < 0;
        const showGrossLossRight = !isIncomeLeft && grossProfit < 0;


        // Determine which side Net Profit should appear
        const showNetProfitLeft = !isIncomeLeft && netProfit >= 0;
        const showNetProfitRight = isIncomeLeft && netProfit >= 0;
        const showNetLossLeft = isIncomeLeft && netProfit < 0;
        const showNetLossRight = !isIncomeLeft && netProfit < 0;
        return {
            isIncomeLeft,
            showNetProfitLeft, showNetProfitRight, showNetLossLeft, showNetLossRight,
            showGrossProfitLeft, showGrossProfitRight, showGrossLossLeft, showGrossLossRight,
            leftMainGroups, rightMainGroups, leftMainTotal, rightMainTotal
            ,leftOtherGroups, rightOtherGroups, leftOtherTotal, rightOtherTotal,
            leftTitle, rightTitle, leftOtherTitle, rightOtherTitle, leftMainRows, rightMainRows, leftOtherRows, rightOtherRows

        };
    }, [main, other, selRptFormat])

    const NetRow = ({ showLoss, showProfit }) => {
        const label = showLoss ? "NET LOSS" : showProfit ? "NET PROFIT" : "-";
        return (
            <tr className={label !== "-" ? head_class : ""}>
                <td className={`${border_class} px-2 py-1 text-right`}>{label}</td>
                <td className={`${border_class} px-2 py-1 text-right`}>
                    {label === "-" ? "-" : formatCurrency(Math.abs(netProfit))}
                </td>
            </tr>
        );
    };
    const GrossRow = ({ showGrossLoss, showGrossProfit }) => {
        const label = showGrossLoss ? "GROSS LOSS" : showGrossProfit ? "GROSS PROFIT" : "-";

        return (
            <tr className={label !== "-" ? head_class : ""}>
                <td className={`${border_class} px-2 py-1 text-right`}>{label}</td>
                <td className={`${border_class} px-2 py-1 text-right`}>
                    {label === "-" ? "-" : formatCurrency(Math.abs(grossProfit))}
                </td>
            </tr>
        );
    };
    useEffect(() => {

        const leftRows = document.querySelectorAll(".income-table tr");
        const rightRows = document.querySelectorAll(".expense-table tr");


        const max = Math.max(leftRows.length, rightRows.length);

        for (let i = 0; i < max; i++) {
            const l = leftRows[i];
            const r = rightRows[i];

            if (l && r) {
                const h = Math.max(l.offsetHeight, r.offsetHeight);
                l.style.height = `${h}px`;
                r.style.height = `${h}px`;
            }
        }
        const otherLeftRows = document.querySelectorAll(".other-income-table tr");
        const otherRightRows = document.querySelectorAll(".other-expense-table tr");

        const otherMax = Math.max(otherLeftRows.length, otherRightRows.length);

        for (let i = 0; i < otherMax; i++) {
            const l = otherLeftRows[i];
            const r = otherRightRows[i];

            if (l && r) {
                const h = Math.max(l.offsetHeight, r.offsetHeight);
                l.style.height = `${h}px`;
                r.style.height = `${h}px`;
            }
        }
    }, [main, other]);

    const GroupTable = ({ groups = {}, col1Width = "w-[70%]", col2Width = "w-[30%]", grpType = "" }) => {

        const groupKeys = Object.keys(groups)

        return (
            <>
                <colgroup>
                    <col className={col1Width} />
                    <col className={col2Width} />
                </colgroup>
                {/* {grpType == "otherIncome" ? <tr className="font-bold text-purple-600"> */}
                {grpType == "otherIncome" ? <tr className="font-bold text-purple-600">
                    <td className={` ${border_class} px-2 py-1`}>{grossProfit >= 0 ? "GROSS PROFIT" : "-"}</td>
                    <td className={` ${border_class} px-2 py-1 text-right`} >{grossProfit > 0 ? Math.abs(grossProfit).toLocaleString() : "-"}</td>
                </tr> : ""}
                {grpType == "otherExp" ? <tr className="font-bold text-purple-600">
                    <td className={` ${border_class} px-2 py-1 `}>{grossProfit < 0 ? "GROSS LOSS" : "-"}</td>
                    <td className={` ${border_class} px-2 py-1 text-right`}>{grossProfit < 0 ? Math.abs(grossProfit).toLocaleString() : "-"}</td>
                </tr> : ""}
                {groupKeys.map((group, i) => {

                    const rows = groups[group] || []

                    const total = rows.reduce((sum, r) => sum + r.amount, 0)

                    return (
                        <Fragment key={i}>

                            {/* Group Header */}
                            <tr className="bg-gray-50 font-bold text-blue-600">
                                <td colSpan="2" className={` ${border_class} px-2 py-1 uppercase`} style={{ fontSize: "0.7rem" }} >
                                    {group || ""}
                                </td>
                            </tr>

                            {/* Rows */}
                            {rows.map((row, j) => (
                                <tr key={j}>
                                    <td className={` ${border_class} px-2 py-1 uppercase truncate`} style={{ fontSize: "0.7rem" }}>
                                        {row?.desc || ""}
                                    </td>
                                    <td className={` ${border_class} px-2 py-1  text-right`}>
                                        {formatCurrency(row?.amount) || ""}
                                    </td>
                                </tr>
                            ))}

                            {/* Group Total */}
                            <tr className="font-bold bg-graye-50 text-purple-600">
                                <td className={` ${border_class} px-2 py-1 text-right`} style={{ fontSize: "0.7rem" }}>
                                    {group ? `TOTAL ${group} :` : ""}
                                </td>
                                <td className={` ${border_class} px-2 py-1 text-right`}>
                                    {formatCurrency(total)}
                                </td>
                            </tr>

                        </Fragment>
                    )
                })}
            </>
        )
    }
    const grpHead_class = ' bg-amber-100  text-slate-600  text-center font-bold'
    const head_class = '  bg-white  text-purple-600  font-bold'

    // Main export function


    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    // Add report and company headers
    const addReportHeaders = (sheet, reportName, companyName) => {

        sheet.addRow([]);
        const companyRow = sheet.addRow([companyName]);
        sheet.mergeCells(companyRow.number, 1, companyRow.number, 4);
        companyRow.font = { bold: true, italic: true, size: 14 };
        companyRow.alignment = { horizontal: "center" };

        const titleRow = sheet.addRow([reportName]);
        sheet.mergeCells(titleRow.number, 1, titleRow.number, 4);
        titleRow.font = { bold: true, size: 12 };
        titleRow.alignment = { horizontal: "center" };

        const blankRow = sheet.addRow([`Generated On : ${formatDate(new Date())}`]);
        sheet.mergeCells(blankRow.number, 1, blankRow.number, 4);
        blankRow.font = { size: 8 };
        blankRow.alignment = { horizontal: "right" };
        //sheet.addRow([]);
    };

    // Income / Expense titles above headers
    const addIncomeExpenseTitles = (sheet, type) => {
        const row = type == "other" ? sheet.addRow([leftOtherTitle, "", rightOtherTitle, ""]) : sheet.addRow([leftTitle, "", rightTitle, ""]);
        sheet.mergeCells(`A${sheet.lastRow.number}:B${sheet.lastRow.number}`);
        sheet.mergeCells(`C${sheet.lastRow.number}:D${sheet.lastRow.number}`);
        row.font = { bold: true, color: { argb: "000000" }, size: 11 };
        row.alignment = { horizontal: "center" };
        fillFirstFourCells(row, "fef3c7")//FFCC99
        // row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D44953" } }; // blue
    };

    // Column headers
    const addColumnHeaders = (sheet) => {
        const row = sheet.addRow(["GROUP / ACCOUNT DESC.", `AMOUNT(${isIncomeLeft ? "INC" : "EXP"})`, "GROUP / ACCOUNT DESC.", `AMOUNT(${isIncomeLeft ? "EXP" : "INC"})`]);
        row.font = { bold: true, color: { argb: "FFFFFF" } };
        row.alignment = { horizontal: "center" };
        fillFirstFourCells(row, "148AF0")
        //row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "C2DEFA" } }; // gray
    };

    // Build aligned Income/Expense rows
    const buildAlignedRows = (incomeData, expenseData) => {
        const incomeGroups = Object.entries(incomeData || {}).map(([group, items]) => ({
            group,
            items,
            total: items.reduce((sum, i) => sum + (i.amount || 0), 0),
        }));
        const expenseGroups = Object.entries(expenseData || {}).map(([group, items]) => ({
            group,
            items,
            total: items.reduce((sum, i) => sum + (i.amount || 0), 0),
        }));

        const rows = [];
        let iIdx = 0, eIdx = 0, iSub = 0, eSub = 0;
        let iGroup = incomeGroups[iIdx];
        let eGroup = expenseGroups[eIdx];

        while (iGroup || eGroup) {
            const row = ["", "", "", ""];

            // Income side
            if (iGroup) {
                if (iSub === 0) row[0] = iGroup.group;
                else if (iSub <= iGroup.items.length) {
                    const item = iGroup.items[iSub - 1];
                    row[0] = "   " + item.desc;
                    row[1] = formatCurrency(item.amount);
                } else if (iSub === iGroup.items.length + 1) {
                    row[0] = "TOTAL " + iGroup.group;
                    row[1] = formatCurrency(iGroup.total);
                }
                iSub++;
                if (iSub > iGroup.items.length + 1) {
                    iIdx++;
                    iGroup = incomeGroups[iIdx];
                    iSub = 0;
                }

            }

            // Expense side
            if (eGroup) {
                if (eSub === 0) row[2] = eGroup.group;
                else if (eSub <= eGroup.items.length) {
                    const item = eGroup.items[eSub - 1];
                    row[2] = "   " + item.desc;
                    row[3] = formatCurrency(item.amount);
                } else if (eSub === eGroup.items.length + 1) {
                    row[2] = "TOTAL " + eGroup.group;
                    row[3] = formatCurrency(eGroup.total);
                }
                eSub++;
                if (eSub > eGroup.items.length + 1) {
                    eIdx++;
                    eGroup = expenseGroups[eIdx];
                    eSub = 0;
                }

            }

            rows.push(row);
        }

        return rows;
    };

    const fillFirstFourCells = (row, color) => {
        for (let i = 1; i <= 4; i++) {
            const cell = row.getCell(i);

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: color },
            };
        }
    };
    // Main export function
    const exportToExcel = async (main, other, totals) => {
        const { finalIncomeTotal, finalExpenseTotal, grossProfit, netProfit } = totals;
        const reportName = `Profit And Loss Report From Date ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`
        const companyName = compName.join(",")
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Financial Report");
        const _fontSize = 10;
        sheet.columns = [
            { width: 40 }, { width: 18 }, { width: 40 }, { width: 18 },
        ];


        const addStyledRow = (rowData) => {
            const row = sheet.addRow(rowData.map((v) => (v ? v : "")));

            // Right align amount columns
            row.font = { size: _fontSize }
            row.getCell(2).alignment = { horizontal: "right" };
            row.getCell(4).alignment = { horizontal: "right" };

            // Income group bold
            if (rowData[0] && !rowData[1] && !rowData[0].startsWith("   "))
                row.getCell(1).font = { bold: true, color: { argb: "4273dc" }, size: _fontSize };

            if (rowData[0] && rowData[0].startsWith("TOTAL")) {
                row.getCell(1).font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
                row.getCell(1).alignment = { horizontal: "right" };
                row.getCell(2).font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
            }

            // Expense group bold
            if (rowData[2] && !rowData[3] && !rowData[2].startsWith("   "))
                row.getCell(3).font = { bold: true, color: { argb: "4273dc" }, size: _fontSize };

            if (rowData[2] && rowData[2].startsWith("TOTAL")) {
                row.getCell(3).font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
                row.getCell(4).font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
                row.getCell(3).alignment = { horizontal: "right" };
            }
        };

        // --- Report headers ---
        addReportHeaders(sheet, reportName, companyName);

        addColumnHeaders(sheet);
        // --- TRADING ACCOUNT ---
        const tradingTitle = sheet.addRow(["TRADING ACCOUNT"]);
        tradingTitle.font = { bold: true, color: { argb: "1d7e07" } };
        tradingTitle.alignment = { horizontal: "center" };
        fillFirstFourCells(tradingTitle, "f0fdf4");
        //tradingTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F5BE29" } }; // yellow
        sheet.mergeCells(`A${sheet.lastRow.number}:D${sheet.lastRow.number}`);

        addIncomeExpenseTitles(sheet, "");


        const tradingRows = buildAlignedRows(leftMainGroups, rightMainGroups);
        tradingRows.forEach(addStyledRow);

        const tadingTotalRow = sheet.addRow([
            "TOTAL OF TRADING ACCOUNTS",
            formatCurrency(leftMainTotal),
            "",
            formatCurrency(rightMainTotal), "",
        ]);
        tadingTotalRow.alignment = { horizontal: "right" };
        tadingTotalRow.font = { bold: true, size: _fontSize };
        fillFirstFourCells(tadingTotalRow, "fef3c7")//FFCC99

        // Gross Profit / Loss
        if (grossProfit < 0) {
            const grossRow = sheet.addRow(isIncomeLeft ? [
                grossProfit < 0 ? "GROSS LOSS" : "",
                formatCurrency(Math.abs(grossProfit)),
                "",
                "",
            ] : [

                "",
                "",
                grossProfit < 0 ? "GROSS LOSS" : "",
                formatCurrency(Math.abs(grossProfit)),
            ]);
            grossRow.alignment = { horizontal: "right" };
            grossRow.font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };

        }
        else if (grossProfit >= 0) {
            const grossRow = sheet.addRow(isIncomeLeft ? [
                "",
                "",
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatCurrency(Math.abs(grossProfit)),
            ] : [
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatCurrency(Math.abs(grossProfit)),
                "",
                "",
            ]);

            grossRow.alignment = { horizontal: "right" };
            grossRow.font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
        }
        // --- PROFIT & LOSS ACCOUNT ---
        sheet.addRow([])
        const plTitle = sheet.addRow(["PROFIT & LOSS ACCOUNT"]);
        plTitle.font = { bold: true, color: { argb: "1d7e07" } };
        plTitle.alignment = { horizontal: "center" };
        fillFirstFourCells(plTitle, "f0fdf4");
        // plTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F5BE29" } }; // yellow
        sheet.mergeCells(`A${sheet.lastRow.number}:D${sheet.lastRow.number}`);

        addIncomeExpenseTitles(sheet, "other");
        // Add Gross Profit / Loss row in Profit & Loss section


        if (grossProfit >= 0) {
            const grossRow = sheet.addRow(isIncomeLeft ? [
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatCurrency(Math.abs(grossProfit)),
                "",
                "",
            ] : [
                "",
                "",
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatCurrency(Math.abs(grossProfit)), "",
            ]);
            grossRow.font = { bold: true, size: _fontSize };
            grossRow.getCell(2).alignment = { horizontal: "right" };
        }
        else if (grossProfit < 0) {
            const grossRow = sheet.addRow(isIncomeLeft ? [
                "",
                "",
                grossProfit < 0 ? "GROSS LOSS" : "",
                formatCurrency(Math.abs(grossProfit)),
            ] : [

                grossProfit < 0 ? "GROSS LOSS" : "",
                formatCurrency(Math.abs(grossProfit)),
                "",
                "",
            ]);

            grossRow.font = { bold: true, size: _fontSize };
            grossRow.getCell(4).alignment = { horizontal: "right" };
        }
        //addColumnHeaders(sheet);
        const plRows = buildAlignedRows(leftOtherGroups, rightOtherGroups);
        plRows.forEach(addStyledRow);

        const plTotalRow = sheet.addRow([
            "TOTAL OF OTHER INCOME/EXP.(ADMIN)",
            formatCurrency(leftOtherTotal),
            "",
            formatCurrency(rightOtherTotal), "",
        ]);
        plTotalRow.alignment = { horizontal: "right" };
        plTotalRow.font = { bold: true, size: _fontSize };
        fillFirstFourCells(plTotalRow, "fef3c7")//FFCC99

        // Net Profit / Loss
        if (netProfit >= 0) {

            const netRow = sheet.addRow(isIncomeLeft ? [
                "",
                "",
                netProfit >= 0 ? "NET PROFIT" : "NET LOSS",
                formatCurrency(Math.abs(netProfit)),

            ] : [

                netProfit >= 0 ? "NET PROFIT" : "NET LOSS",
                formatCurrency(Math.abs(netProfit)),
                "",
                "",

            ]);
            netRow.font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
            netRow.alignment = { horizontal: "right" };
        }
        else if (netProfit < 0) {
            const netRow = sheet.addRow(isIncomeLeft ? [

                netProfit >= 0 ? "NET PROFIT" : "NET LOSS",
                formatCurrency(Math.abs(netProfit)),
                "",
                "",
            ] : [
                "",
                "",
                netProfit >= 0 ? "NET PROFIT" : "NET LOSS",
                formatCurrency(Math.abs(netProfit)),
            ]);
            netRow.font = { bold: true, color: { argb: "9333ea" }, size: _fontSize };
            netRow.alignment = { horizontal: "right" };
        }


        // Final totals row
        const finalRow = sheet.addRow([
            "FINAL TOTAL",
            formatCurrency(isIncomeLeft ? finalIncomeTotal : finalExpenseTotal),
            "",
            formatCurrency(isIncomeLeft ? finalExpenseTotal : finalIncomeTotal),
        ]);
        finalRow.font = { bold: true, color: { argb: "FFFFFF" }, size: _fontSize };
        finalRow.alignment = { horizontal: "right" };
        fillFirstFourCells(finalRow, "148AF0")

        //finalRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF38BDF8" } };

        // Export Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `${reportName}.xlsx`);
    };


    const buildRows = (income = {}, expense = {}) => {

        const incomeGroups = Object.entries(income);
        const expenseGroups = Object.entries(expense);

        let rows = [];

        let max = Math.max(incomeGroups.length, expenseGroups.length);

        for (let g = 0; g < max; g++) {

            const inc = incomeGroups[g];
            const exp = expenseGroups[g];

            const incItems = inc ? inc[1] : [];
            const expItems = exp ? exp[1] : [];

            const incTotal = incItems.reduce((s, i) => s + i.amount, 0);
            const expTotal = expItems.reduce((s, i) => s + i.amount, 0);

            rows.push([
                { content: inc ? inc[0] : "", styles: { halign: "left", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: exp ? exp[0] : "", styles: { halign: "left", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },

                // inc ? inc[0] : "",
                // "",
                // exp ? exp[0] : "",
                // ""
            ]);

            let itemMax = Math.max(incItems.length, expItems.length);

            for (let i = 0; i < itemMax; i++) {

                rows.push([
                    incItems[i] ? "   " + incItems[i].desc : "",
                    incItems[i] ? formatCurrency(incItems[i].amount) : "",
                    expItems[i] ? "   " + expItems[i].desc : "",
                    expItems[i] ? formatCurrency(expItems[i].amount) : ""
                ]);

            }

            rows.push([
                { content: inc ? inc[0] + " TOTAL : " : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: inc ? formatCurrency(incTotal) : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: exp ? exp[0] + " TOTAL :" : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: exp ? formatCurrency(expTotal) : "", styles: { halign: "right", fontStyle: "bold" } },

                // inc ? formatNumber(incTotal) : "",
                // exp ? "TOTAL " + exp[0] : "",
                // exp ? formatNumber(expTotal) : ""
            ]);

        }

        return rows;
    };

    const exportFinancialPDF = (
        main,
        other,
        totals,
    ) => {

        const {
            grossProfit,
            netProfit,
            finalIncomeTotal,
            finalExpenseTotal
        } = totals;
        const reportName = `Profit And Loss Report From Date ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`
        const companyName = compName.join(",")
        const reportDate = new Date().toLocaleDateString("en-GB");

        const doc = new jsPDF();

        let body = [];

        // ---------- TRADING TITLE ----------
        body.push([
            { content: "TRADING ACCOUNT", colSpan: 4, styles: { halign: "center", fontStyle: "bold", fillColor: [235, 235, 235] } }
        ]);
        body.push([
            { content: leftTitle, colSpan: 2, styles: { halign: "center", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: rightTitle, colSpan: 2, styles: { halign: "center", fontStyle: "bold", textColor: "#0f72c8" } }
        ]);


        let tradingRows = buildRows(
            leftMainGroups,
            rightMainGroups
        );

        body.push(...tradingRows);

        body.push([
            { content: "TOTAL OF TRADING ACCCOUNTS", styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: formatCurrency(leftMainTotal) || "", styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: "", styles: { halign: "left", fontStyle: "bold", } },
            { content: formatCurrency(rightMainTotal), styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },

        ]);
        // Gross Profit
        if (grossProfit > 0) {

            body.push(isIncomeLeft ? [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(grossProfit), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },

            ] : [
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(grossProfit), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },]);

        } else {

            body.push(isIncomeLeft ? [
                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },

            ] : [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },

            ]);
        }

        // ---------- PROFIT LOSS TITLE ----------
        body.push([
            { content: "PROFIT & LOSS ACCOUNT", colSpan: 4, styles: { halign: "center", fontStyle: "bold", fillColor: [235, 235, 235] } }
        ]);
        body.push([
            { content: leftOtherTitle, colSpan: 2, styles: { halign: "center", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: rightOtherTitle, colSpan: 2, styles: { halign: "center", fontStyle: "bold", textColor: "#0f72c8" } }
        ]);
        if (grossProfit >= 0) {
            body.push(isIncomeLeft ? [
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatCurrency(grossProfit), styles: { halign: "right", fontStyle: "bold" } }
            ] : [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatCurrency(grossProfit), styles: { halign: "right", fontStyle: "bold" } }
            ]);
        }
        else if (grossProfit < 0) {
            body.push(isIncomeLeft ? [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatCurrency(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold" } }
            ] : [
                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatCurrency(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
            ]);
        }


        let plRows = buildRows(
            leftOtherGroups,
            rightOtherGroups
        );

        body.push(...plRows);


        body.push([
            { content: "TOTAL OF OTHER INCOME/EXP.(ADMIN)", styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: formatCurrency(leftOtherTotal) || "", styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },
            { content: "", styles: { halign: "left", fontStyle: "bold", } },
            { content: formatCurrency(rightOtherTotal), styles: { halign: "right", fontStyle: "bold", textColor: "#0f72c8" } },

        ]);
        // Net Profit
        if (netProfit > 0) {

            body.push(isIncomeLeft ? [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "NET PROFIT", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(netProfit), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },

            ] : [
                { content: "NET PROFIT", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(netProfit), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },

            ]);

        } else {

            body.push(isIncomeLeft ? [
                { content: "NET LOSS", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(Math.abs(netProfit)), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
            ] : [
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "NET LOSS", styles: { halign: "left", fontStyle: "bold", textColor: "#049477" } },
                { content: formatCurrency(Math.abs(netProfit)), styles: { halign: "right", fontStyle: "bold", textColor: "#049477" } },
            ]);
        }

        // Final totals
        body.push([
            { content: "FINAL TOTAL", styles: { halign: "right", fontStyle: "bold", textColor: "#FFFFFF", fillColor: "#1abd9c" } },
            { content: formatCurrency(isIncomeLeft ? finalIncomeTotal : finalExpenseTotal), styles: { halign: "right", fontStyle: "bold", textColor: "#FFFFFF", fillColor: "#1abd9c" } },
            { content: "", styles: { halign: "right", fontStyle: "bold", textColor: "#FFFFFF", fillColor: "#1abd9c" } },
            { content: formatCurrency(isIncomeLeft ? finalExpenseTotal : finalIncomeTotal), styles: { halign: "right", fontStyle: "bold", textColor: "#FFFFFF", fillColor: "#1abd9c" } },
        ]);

        autoTable(doc, {
            startY: 23,
            head: [
                ["GROUP/ACCOUNT DESC.", `AMOUNT (${isIncomeLeft ? "INC" : "EXP"})`, "GROUP/ACCOUNT DESC.", `AMOUNT (${isIncomeLeft ? "EXP" : "INC"})`]
            ],

            body: body,
            theme: "grid",
            styles: {
                fontSize: 7
            },
            headStyles: {
                fontSize: 8,
                fillColor: "#1abd9c",
                color: "#FFFFFF",
                halign: "center"
            },
            columnStyles: {
                1: { halign: "right" },
                3: { halign: "right" }
            }, didDrawPage: function (data) {
                // 🔵 Company Name
                data.settings.margin.top = 23;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                doc.setFontSize(14);
                doc.setFont(undefined, "bold");
                doc.text(companyName, doc.internal.pageSize.getWidth() / 2, 15, {
                    align: "center",
                });

                // 🔵 Report Name
                doc.setFontSize(11);
                doc.setFont(undefined, "bold");
                doc.text(reportName, doc.internal.pageSize.getWidth() / 2, 20, {
                    align: "center",
                });

                
                doc.setFontSize(9);
                doc.text(
                    `Generated on: ${reportDate}`,
                    14,
                    pageHeight - 10
                );
                // 🔴 Page Number
                const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                const totalPages = doc.internal.getNumberOfPages();

                doc.setFontSize(9);
                doc.text(
                    `Page ${pageNumber} of ${totalPages}`,
                    pageWidth - 20,
                    pageHeight - 10
                );
            },

        });

        doc.save(`${reportName}.pdf`);

    };


    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }
    return (
        <div>


            <MainContainer
                pageName="Profit And Loss Report"
                info={[]}
                breadcrumbs={["Reports & view", "Final Reports","Profit And Loss Report"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex   flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">

                        <Select
                            selectedKeys={[selRptFormat]}
                            variant="bordered"
                            color="warning"
                            size="sm"
                            label="FORMAT "
                            //labelPlacement="outside"
                            onChange={(e) => setSelRptFormat(e.target.value)}
                            classNames={{ label: "text-sm py-1" }}
                            className="w-full sm:w-48 md:w-48 text-xs  font-semibold"
                        >
                            <SelectItem key="INCEXP" className="text-xs">INCOME_EXPENSE</SelectItem>
                            <SelectItem key="EXPINC">EXPENSE_INCOME</SelectItem>
                        </Select>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"From Date"}
                                views={["day", "month", "year"]}
                                size="small"
                                format="DD/MM/YYYY"
                                className="w-full sm:w-40 md:w-40"
                                value={
                                    billDate.fromDate
                                        ? dayjs(billDate.fromDate)
                                        : billDate.fromDate
                                }
                                onChange={(newValue) => {
                                    setBillDate((prev) => {
                                        return {
                                            ...prev,
                                            fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                        };
                                    });
                                }}
                                slotProps={{
                                    textField: { size: "small", },
                                }}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"To  Date"}
                                views={["day", "month", "year"]}
                                format="DD/MM/YYYY"
                                size="small"
                                className="w-full sm:w-40 md:w-40"
                                value={
                                    billDate.toDate
                                        ? dayjs(billDate.toDate)
                                        : billDate.toDate
                                }
                                onChange={(newValue) => {
                                    setBillDate((prev) => {
                                        return {
                                            ...prev,
                                            toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                        };
                                    });
                                }}
                                slotProps={{
                                    textField: { size: "small", },
                                }}
                            />
                        </LocalizationProvider>

                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter}
                                startContent={<FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>}
                                className="font-semibold uppercase bg-sky-700 text-white" variant="solid" color="primary" size="sm" >Find</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                        </div>
                    </div>
                </div>
                {data && data.length > 0 ?
                    <div className="p-4">

                        <div className="flex gap-2 justify-end">
                            <button onClick={() => exportToExcel(main, other, { finalIncomeTotal, finalExpenseTotal, 
                            grossProfit, netProfit })}
                                className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                            >
                                Export Excel
                            </button>
                            <button onClick={() => exportFinancialPDF(
                                main,
                                other,
                                {
                                    grossProfit,
                                    netProfit,
                                    finalIncomeTotal,
                                    finalExpenseTotal
                                },

                            )} className="px-3 py-1 bg-red-600 text-white rounded text-sm">Export PDF</button>
                        </div>
                        <table className="w-full border border-slate-700 table-fixed border-collapse text-xs font-medium">
                            <colgroup>
                                <col className={col_1Width} />
                                <col className={col_2Width} />
                                <col className={col_1Width} />
                                <col className={col_2Width} />
                            </colgroup>
                            <thead>
                                <tr className={`font-bold  bg-sky-600 text-white uppercase`}>
                                    <th className={` ${border_class} border-t-gray-50  border-b-gray-50 border-r-gray-50 px-2 py-1 text-left `}>Group / Account Desc.</th>
                                    <th className={` ${border_class} border-gray-50 px-2 py-1 text-right`}>{`Amount (${isIncomeLeft ? "INC" : "EXP"})`}</th>
                                    <th className={` ${border_class} border-gray-50 px-2 py-1 text-left `}>Group / Account Desc.</th>
                                    <th className={` ${border_class}  border-t-gray-50  border-b-gray-50 border-l-gray-50 px-2 py-1 text-right `}>{` Amount (${isIncomeLeft ? "EXP" : "INC"})`}</th>
                                </tr>

                            </thead>

                            <tbody>
                                {/* --- TRADING ACCOUNT --- */}
                                <tr className="  bg-green-50  text-green-700 font-bold text-center">
                                    <td colSpan="4" className={` ${border_class}  py-1 `}>TRADING ACCOUNT</td>
                                </tr>
                                <tr className={`${grpHead_class}`}>
                                    <th colSpan="2">{leftTitle}</th>
                                    <th colSpan="2">{rightTitle}</th>
                                </tr>
                                <tr>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed  income-table">
                                            <GroupTable groups={leftMainGroups} grpType="main" />

                                            {rightMainRows > leftMainRows
                                                ? renderBlankRow(rightMainRows, leftMainRows)
                                                : null}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>
                                                <td className={` ${border_class}  px-2 py-1 text-right`}>TOTAL OF TRADING ACCOUNTS</td>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>{formatCurrency(leftMainTotal)}</td>

                                            </tr>

                                            {/* Gross Profit / Loss Row */}
                                            <GrossRow showGrossLoss={showGrossLossLeft} showGrossProfit={showGrossProfitLeft} />

                                        </table>
                                    </td>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed expense-table">
                                            <GroupTable groups={rightMainGroups} grpType="main" />

                                            {leftMainRows > rightMainRows
                                                ? renderBlankRow(leftMainRows, rightMainRows)
                                                : null}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>

                                                <td className={` ${border_class}   px-2 py-1 text-right`}></td>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>{formatCurrency(rightMainTotal)}</td>
                                            </tr>

                                            <GrossRow showGrossLoss={showGrossLossRight} showGrossProfit={showGrossProfitRight} ></GrossRow>

                                        </table>
                                    </td>
                                </tr>                   {/* --- PROFIT & LOSS ACCOUNT --- */}
                                <tr className=" bg-green-50  text-green-700 font-bold text-center">
                                    <td colSpan="4" className={` ${border_class}  py-1 `}>PROFIT & LOSS ACCOUNT</td>
                                </tr>

                                {/* Column Titles */}
                                <tr className={`${grpHead_class}`}>
                                    <td colSpan="2" className={` ${border_class}  py-1 `}>{leftOtherTitle}</td>
                                    <td colSpan="2" className={` ${border_class}  py-1 `}>{rightOtherTitle}</td>
                                </tr>
                                {/* Gross Profit Row */}

                                {/* Other Income/Expense Groups */}
                                <tr>
                                    <td colSpan={2} className="align-top">

                                        <table className="w-full table-fixed other-income-table">

                                            <GroupTable groups={leftOtherGroups} grpType={isIncomeLeft ? "otherIncome" : "otherExp"} />

                                            {rightOtherRows > leftOtherRows
                                                ? renderBlankRow(rightOtherRows, leftOtherRows)
                                                : null}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>TOTAL OF OTHER INCOME/EXP.(ADMIN)</td>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>{formatCurrency(leftOtherTotal)}</td>

                                            </tr>

                                            {/* NET Profit / Loss */}
                                            <NetRow showLoss={showNetLossLeft} showProfit={showNetProfitLeft} />

                                            <tr className="bg-sky-600 text-white">
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>
                                                    FINAL TOTAL
                                                </td>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>
                                                    {formatCurrency(isIncomeLeft ? finalIncomeTotal : finalExpenseTotal)}
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed other-expense-table ">

                                            <GroupTable groups={rightOtherGroups} grpType={isIncomeLeft ? "otherExp" : "otherIncome"} />

                                            {leftOtherRows > rightOtherRows
                                                ? renderBlankRow(leftOtherRows, rightOtherRows)
                                                : null}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>

                                                <td className={` ${border_class}   px-2 py-1 text-right`}></td>
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>{formatCurrency(rightOtherTotal)}</td>
                                            </tr>

                                            {/* NET Profit / Loss */}
                                            <NetRow showLoss={showNetLossRight} showProfit={showNetProfitRight} ></NetRow>
                                            <tr className="bg-sky-600 text-white">
                                                <td className={` ${border_class}   px-2 py-1 text-right`}>
                                                    FINAL TOTAL
                                                </td>
                                                <td className={` ${border_class}  px-2 py-1 text-right`}>
                                                    {formatCurrency(isIncomeLeft ? finalExpenseTotal : finalIncomeTotal)}
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                </tr>


                            </tbody>

                        </table>
                    </div>
                    :
                    !isPending && (
                        <div className="p-4 border-1 text-center"

                        >
                            <div className="flex justify-center  items-center flex-column gap-2"                 >
                                <FontAwesomeIcon icon={faInfo} />
                                {/* <DescriptionOutlined sx={{
                  fontSize: 48,
                  color: 'text.disabled'
                }} /> */}
                                <h6 className="text-slate-500">
                                    No  data available
                                </h6>
                                <h6 className="text-slate-500">
                                    Apply filters above to generate a report
                                </h6>
                            </div>
                        </div>
                    )}


            </MainContainer>
        </div>
    )
}
export default ProfitNLossReport


{/* <tr className="font-bold ">
                                            <td className="border border-black px-2 py-1">{grossProfit < 0 ? "GROSS LOSS" : "-"}</td>
                                            <td className="border border-black px-2 py-1 text-right">{grossProfit < 0 ? grossProfit.toLocaleString() : "-"}</td>
                                        </tr>
                                        {(() => {
                                            const expenseGroups = Object.keys(other.tradingData.Expense);
                                            const maxGroups = expenseGroups.length;

                                            return [...Array(maxGroups)].map((_, i) => {
                                                const expenseGrp = expenseGroups[i];
                                                const expenseRows = other.tradingData.Expense[expenseGrp] || [];
                                                const maxRows = expenseRows.length;
                                                const expenseTotal = expenseRows.reduce((s, r) => s + r.amount, 0);

                                                return (
                                                    <Fragment key={i}>
                                                        
                                                        <tr className="bg-gray-50 font-bold">
                                                            <td colSpan="2" className="border border-black px-2 py-1 font-bold">{expenseGrp || ""}</td>
                                                        </tr>

                                                       
                                                        {[...Array(maxRows)].map((_, j) => (
                                                            <tr key={j}>

                                                                <td className="border border-black px-2 py-1">{expenseRows[j]?.desc || ""}</td>
                                                                <td className="border border-black px-2 py-1 text-right">{expenseRows[j]?.amount?.toLocaleString() || ""}</td>
                                                            </tr>
                                                        ))}

                                                        
                                                        <tr className="font-bold bg-gray-100">

                                                            <td className="border border-black px-2 py-1 text-right">{expenseGrp ? expenseGrp + " TOTAL" : ""}</td>
                                                            <td className="border border-black px-2 py-1 text-right">{expenseTotal.toLocaleString()}</td>
                                                        </tr>
                                                    </Fragment>
                                                );
                                            });
                                        })()} */}